export default {
  ALKALINE_ELECTROLYSIS: 'ALKALINE_ELECTROLYSIS',
  PROTON_EXCHANGE_MEMBRANE_ELECTROLYSIS:
    'PROTON_EXCHANGE_MEMBRANE_ELECTROLYSIS',
  SOLID_OXIDE_ELECTROLYSIS: 'SOLID_OXIDE_ELECTROLYSIS',
};
